var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"app-container"},[_c('app-navigation'),_c('v-main',[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{on:{"add-root-class":_vm.addRootClass,"remove-root-class":_vm.removeRootClass}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }